import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";

interface ConsentStatus {
  needs_consent: boolean;
  pending_types: string[];
}

export function useConsentStatus() {
  return useQuery<ConsentStatus>({
    queryKey: ["consent-status"],
    queryFn: () => api.get<ConsentStatus>("/athlete/consent/status").then((r) => r.data),
    staleTime: 5 * 60 * 1000,
  });
}

export function useAcceptConsent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (consent_types: string[]) =>
      api.post("/athlete/consent/accept", { consent_types }),
    onSuccess: () => {
      qc.setQueryData(["consent-status"], { needs_consent: false, pending_types: [] });
    },
  });
}
